import * as React from "react";
import { useState, useEffect, useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import GroupsIcon from "@mui/icons-material/Groups";
import Table from "@mui/material/Table";
import { useUser } from "../../context/UserContext";
import { BASE_URL } from "../../utils/config"; 
import moment from "moment";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import profile from "../../assets/imgs/passport.png";
import Typography from "@mui/material/Typography";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import currency from "../../utils/formatCurrency";
import { Doughnut } from "react-chartjs-2";
import Modal from "@mui/material/Modal";
import { Chart, ArcElement } from "chart.js";
import Loading from "../../utils/loading";
import Toast from "../../utils/Toast"
import Stack from "@mui/material/Stack";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MenuIcon from '@mui/icons-material/Menu';
import { useVendor } from "../../context/VendorSignupContext";
import CloseIcon from '@mui/icons-material/Close';
Chart.register(ArcElement);

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
const data = {
  datasets: [
    {
      data: [83, 20],

      backgroundColor: ["rgba(236, 112, 122, 1)", "rgba(16, 172, 126, 1)"],
    },
  ],
};
var config = {
  cutout: 28,
  responsive: true,
  maintainAspectRatio: true,
  options: {},
};
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const OrderManagement = () => {
  const { user, setUser } = useUser();
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);
  const [orderStatus, setOrderStatus] = useState("");
  const [allOrders, setAllOrders] = useState([]);
  const [newVendorModal, setNewVendorModal] = useState(false);
  const handleModalClose = () => setNewVendorModal(false);
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const {
    visible,
    setVisible,
  } = useVendor();
  const showSidebar = () => {
    setVisible(true)
  }
  const hideSidebar = () => {
    setVisible(false)
  }


  const handleViewOrder = useCallback(
    (order) => {
      navigate(`/app/order/${order?.id}`, { state: { order } });
    },
    [navigate]
  );


  // Mark Order as paid or unpaid Admin Routes only
  const handleOrderPaymentStatus = async( orderStatus, e)=> {
    setLoading(true);
    const selectedStatus = e?.target?.value;
    console.log("Order:", orderStatus);
    console.log("Selected Status:", selectedStatus);

    const requestBody = {
      payment_status: selectedStatus
    };
  
    try {
      const response = await fetch(`${BASE_URL}/sales/updatepayment/${orderStatus?.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + user?.token,
        },
        body: JSON.stringify(requestBody),
      });
  
      const result = await response.json();
      setLoading(false);
      if(result.status) {
        setToast({ message: `Successful!... ${result.message}`, type: "success" });
          setTimeout(() => setToast(null), 5000);
          getMyOrder();
      console.log("Upating Order:", result);
      }else {
        setToast({ message: `Failed!... ${result.message}`, type: "error" });
        setOrderStatus("");
        setTimeout(() => setToast(null), 5000);
    console.log("Error Upating Order:", result);
      }
    } catch (error) {
      console.error("Error:", error);
      setToast({ message: `Failed... ${error}`, type: "error" });
          setTimeout(() => setToast(null), 5000);
          setLoading(false);
          setOrderStatus("");
          return false; //  failed
    }
    setLoading(false);
  }


  const getProcessedCount = (products) => {
    if (!products) return 0;
    return products.filter(
      (p) => p?.order?.status === "pushed" || p?.order?.status === "received"
    ).length;
  };


  const getMyOrder = async () => {
    setLoading(true);
    console.log(user);
  let determinWhoseOrder = 
  user.accountType === "Stockist" ? "stockist/allorder" : 
  user.accountType === "Vendor" ? "sales/vendorsales" : 
  user.accountType === "Admin" ? "sales" : "";
  console.log(determinWhoseOrder);
    try {
      const response = await fetch(`${BASE_URL}/${determinWhoseOrder}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });
  
      const result = await response.json();
      console.log(result);
      if(result.status) {
        setAllOrders(result?.data || []);
      }
      
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };
  

  const handleOrderStatus = async (orderStatus, e) => {
    setLoading(true);
    const selectedStatus = e?.target?.value;
    console.log("Order:", orderStatus);
    console.log("Selected Status:", selectedStatus);

    const requestBody = {
      status: selectedStatus
    };
  
    try {
      const response = await fetch(`${BASE_URL}/order/${orderStatus?.id}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + user?.token,
        },
        body: JSON.stringify(requestBody),
      });
  
      const result = await response.json();
      setLoading(false);
      if(result.status) {
        setToast({ message: `Successful!... ${result.message}`, type: "success" });
          setTimeout(() => setToast(null), 5000);
          getMyOrder();
      console.log("Upating Order:", result);
      }else {
        setToast({ message: `Failed!... ${result.message}`, type: "error" });
        setOrderStatus("");
        setTimeout(() => setToast(null), 5000);
    console.log("Error Upating Order:", result);
      }
    } catch (error) {
      console.error("Error:", error);
      setToast({ message: `Failed... ${error}`, type: "error" });
          setTimeout(() => setToast(null), 5000);
          setLoading(false);
          setOrderStatus("");
          return false; //  failed
    }
    setLoading(false);
  };
  

useEffect(()=>{ 
  getMyOrder();
  console.log(user);
  return;
},[])
  return (
    <section>
          <Loading loading={loading} />
          {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      <section className="page__header">
        <div className="flex-container alc">
          <GroupsIcon />
          <h3>Order Details</h3>
        </div>
        {visible ?
         <div onClick={hideSidebar} className="no-large-display pointer">
          <CloseIcon />
        </div > :  
        <div onClick={showSidebar}  className="no-large-display pointer">
          <MenuIcon />
        </div>
        }
      </section>
      <div className="s-divider"></div>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example">
            <Tab label="All Orders" {...a11yProps(0)} /> 
            <Tab label="Completed" {...a11yProps(1)} />
            <Tab label="Pending" {...a11yProps(2)} />
            <Tab label="Delievered" {...a11yProps(3)} />
            <Tab label="Cancelled" {...a11yProps(3)} />
          </Tabs>
        </Box>
        <section className="flex-container alc p-y my-40">
          <div className="">
            <input
              type="text"
              className="search__bar w-200"
              placeholder="Search by name or ID"
            />
            <select className="search__bar w-200" defaultValue={"default"}>
              <option value="default"> Select Status</option>
              <option value="Status 1"> Status 1</option>
              <option value="Status 2"> Status 2</option>
              <option value="Status 3"> Status 3</option>
              <option value="Status 4"> Status 4</option>
            </select>
          </div>
          <div className="">
            <button
              className="btn btn-primary p-25"
              onClick={() => setNewVendorModal(true)}>
              Back to Store
            </button>
          </div>
        </section>
        <TabPanel value={value} index={0}>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="Vendors Table">
              <TableHead>
                <TableRow>
                  <TableCell>Order Date</TableCell>
                <TableCell>Ref</TableCell>
                {user.accountType !== "Stockist" && (
                  <TableCell>Stockist</TableCell>
                )}
                <TableCell>Products</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Payment</TableCell>
                <TableCell>Delivery</TableCell>
                <TableCell>Actions</TableCell>
                
                </TableRow>
              </TableHead>
              <TableBody>
              { allOrders
                  ?.filter(order => order?.stockist_id) // only orders with a stockist id
                  .map((order, i) => {
                    const shouldShowDropdown =
                      user?.accountType === "Stockist" &&
                      getProcessedCount(order?.products) === order?.products?.length;
                    return (
                <TableRow key={order?.id} style={{textTransform: 'capitalize'}}>
                  <TableCell> 
                  {moment(order.created_at).format("ll")} @{" "}
                            {moment(order.created_at).format("LT")}{" "}
                    </TableCell>
                  <TableCell className="b-r">{ order?.id}</TableCell>
                  {user.accountType !== "Stockist" && (
                  <TableCell>{order?.stockist?.name}</TableCell>
                  )}

                 <TableCell style={{textTransform: "lowercase"}}>
                   {user.accountType === "Stockist" && (
                      <>
                       {getProcessedCount(order?.products)} of &nbsp; 
                      </>
                    )}
                    {order?.products?.length || 0}
                  </TableCell>
                  <TableCell> {currency(order?.total_amount)}</TableCell>
                  <TableCell> {order?.customer?.fname} {order?.customer?.lname} </TableCell>

                  <TableCell>
                    <span className="badge bg-success">{order?.payment_status === "" ? "Pending" : order?.payment_status}</span>  
                    </TableCell>
                  <TableCell>
                    <span className="badge bg-error">{order.status}</span>
                  </TableCell>
                  

                  <TableCell style={{ display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: shouldShowDropdown ? "space-between" : "flex-start",
                                      gap: 8,}}> 
                  <button  onClick={() => handleViewOrder(order)}  class="btn btn-primary p-25" style={{width: '30%'}}>
                     Details
                  </button>
                  {user?.accountType === "Stockist" &&
                    getProcessedCount(order?.products) === (order?.products?.length || 0) && (
                  <>
                  <select
                      name="pickup_location"
                      className="last-name form-control"
                      value={orderStatus}
                      onChange={(e) => handleOrderStatus(order, e)}
                      style={{marginTop: 18, textTransform: 'capitalize', width: '60%', height: 37,
                      padding: 10}}>
                    <option value="">Manage Order</option>
                    <option value="out_for_delivery">Out for Delivery</option>
                    <option value="packaging">Packaging</option>
                    <option value="returned">Returned</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="confirmed">Confirmed</option>
                    <option value="delivered">Delivered</option>
                    <option value="customer_did_not_answer">Customer Didn't Answer Call</option>
                </select>
          </>
                   )} 

            {user?.accountType === 'Admin' && (
                 <>
                  <select
                      name="mark_order"
                      className="last-name form-control"
                      value={orderStatus}
                      onChange={(e) => handleOrderPaymentStatus(order, e)}
                      style={{marginTop: 4, textTransform: 'capitalize', width: '60%'}}>
                    <option value="">Manage Order</option>
                    <option value="paid">Paid</option>
                    <option value="not-paid">Not Paid</option>
                </select>
          </>
                   )} 
                  </TableCell>
                </TableRow>
                    )}
              )}
                
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>
        <TabPanel value={value} index={1}>
          Completed
        </TabPanel>
        <TabPanel value={value} index={2}>
          Pending
        </TabPanel>
        <TabPanel value={value} index={3}>
          Delievered
        </TabPanel>
        <TabPanel value={value} index={4}>
          Cancelled
        </TabPanel>
      </Box>
      {/* Modal for vendors */}
      <Modal
        open={newVendorModal}
        onClose={handleModalClose}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return;
          handleModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Add Vendor</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal">
            <div className="w-200">
              <div className="profile_pic_holder">
                <img src={profile} className="profile_pic" />
                <button className="btn btn-primary p-25 mt-15">
                  Upload Photo
                </button>
              </div>
            </div>
            <form style={{ width: "100%" }}>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Product Name</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="ProductName"
                    placeholder="e.g IPhone 14"
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Product Category</label>
                  <select
                    className="search__bar w-100"
                    defaultValue={"default"}>
                    <option value="default"> Select Category</option>
                    <option value="Parent 1"> Category 1</option>
                    <option value="Parent 2"> Category 2</option>
                    <option value="Parent 3"> Category 3</option>
                    <option value="Parent 4"> Category 4</option>
                  </select>
                </div>
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Product Brand</label>
                  <select
                    className="search__bar w-100"
                    defaultValue={"default"}>
                    <option value="default"> Select Brand</option>
                    <option value="Parent 1"> Brand 1</option>
                    <option value="Parent 2"> Brand 2</option>
                    <option value="Parent 3"> Brand 3</option>
                    <option value="Parent 4"> Brand 4</option>
                  </select>
                </div>
                <div className="pos-rel w100-m10 ">
                  <label>Selling Price</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="sellingPrice"
                    placeholder="1,150,000"
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label> Cost Price</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="costPrice"
                    placeholder="1,100,000"
                  />
                </div>
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  {/* <Stack spacing={3} sx={{ width: 500 }}>
                    <Autocomplete
                      multiple
                      id="tags-outlined"
                      options={top100Films}
                      getOptionLabel={(option) => option.title}
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Tags"
                          placeholder="Tags"
                        />
                      )}
                    />
                  </Stack> */}
                </div>
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label>More Images</label>
                  <input
                    type="file"
                    className="form-control-input "
                    name="moreImages"
                    accept=".jpg,.png,.jpeg"
                    multiple
                  />
                </div>
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Product Description </label>
                  <textarea
                    placeholder="Enter product description"
                    className="form-textarea w-100"></textarea>
                </div>

                <div className="pos-rel w100-m10"></div>
              </section>
              <div className="flex__normal w-30 pull-right mt-35">
                <button
                  onClick={handleModalClose}
                  className="btn btn-secondary p-25 pull-right mr-10">
                  Cancel
                </button>
                <button className="btn btn-primary p-25 pull-right">
                  Save
                </button>
              </div>
            </form>
          </section>
        </Box>
      </Modal>
    </section>
  );
};
export default OrderManagement;
